module.exports = __webpack_public_path__ + "img/home-size.22c5c79e.svg";